import React, { useRef, useState } from "react";
import PropTypes from "prop-types";

const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

const SingleImageUploader = ({ inputField, initialImage, label }) => {
  const normalizedInitial =
    initialImage && /no-photo|missing-image/.test(initialImage)
      ? null
      : initialImage;
  const [imageSrc, setImageSrc] = useState(normalizedInitial);
  const [imageData, setImageData] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    if (file.size > MAX_IMAGE_BYTES) {
      alert("Image too large. Please use a file under 5MB.");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const dataUrl = e.target.result;
      setImageSrc(dataUrl);
      setImageData(dataUrl);
    };
    reader.readAsDataURL(file);
  };

  const inputId = inputField.replace(/[\[\]]/g, "_");

  return (
    <div className="single-image-uploader image-gallery-container">
      {label && <label htmlFor={inputId}>{label}</label>}
      <div className="photo-grid">
        {!imageSrc && (
          <div className="add-photo-card">
            <div className="image-uploader-content-wrapper">
              <span className="uploader-icon">+</span>
              <span className="uploader-text">Add Image</span>
              <input
                id={inputId}
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                title="Add image"
                aria-label="Add image"
              />
            </div>
          </div>
        )}
        {imageSrc && (
          <div className="photo-card">
            <div className="photo-card__preview">
              <img src={imageSrc} alt="Image preview" />
              <div className="photo-card__actions-overlay">
                <button
                  type="button"
                  className="action-btn edit-btn"
                  onClick={() => fileInputRef.current?.click()}
                >
                  Change
                </button>
              </div>
            </div>
            <input
              id={inputId}
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              title="Change image"
              aria-label="Change image"
              className="hidden"
            />
          </div>
        )}
        {imageData && (
          <input type="hidden" name={inputField} value={imageData} />
        )}
      </div>
    </div>
  );
};

SingleImageUploader.propTypes = {
  inputField: PropTypes.string.isRequired,
  initialImage: PropTypes.string,
  label: PropTypes.string,
};

SingleImageUploader.defaultProps = {
  initialImage: null,
  label: null,
};

export default SingleImageUploader;
